import { TransformData } from "interfaces/data-files/data-file-create";

type Spec = Omit<TransformData.StackSpec, "name">;

export const validateSpec = (spec: Spec) => {
  const { source_data, column_renamers, column_types, columns_to_drop } = spec;
  let errors: { [col: string]: string } = {};

  const colTypes = {};
  Object.values(column_types).forEach((types) => {
    Object.entries(types).forEach(([c, t]) => {
      if (colTypes[c] && !colTypes[c].includes(t)) {
        colTypes[c].push(t);
      } else {
        colTypes[c] = [t];
      }
    });
  });

  const colsWithMultipleTypes = Object.keys(colTypes).filter(
    (c) => colTypes[c].length >= 2
  );

  colsWithMultipleTypes.forEach((c) => {
    errors[c] = "Mismatched Types. Check your inputs.";
  });

  return errors;
};
export default validateSpec;
